<template>
    <li class="flex items-center gap-1" v-if="computedTray">
        <BaseSvg
            name="PushPinOutlined"
            aria-hidden="true"
            class="fill-v2-gray-70 rotate-45 dark:fill-v2-gray-90 w-6 h-6 shrink-0"
        />
        <span>
            Added to <button
            @click.prevent="openTray(computedTray, true)"
            class="text-v2-gray-20 underline underline-offset-4 decoration-1 decoration-dotted hover:decoration-solid dark:text-v2-gray-130 print:no-underline"
        >
            {{ computedTray?.name }}
        </button>
        </span>
    </li>
</template>

<script setup>
import {usePinsDrawer} from "@/Composables";
import {computed} from "vue";

const props = defineProps(['tray']);
const { openTray, drawer } = usePinsDrawer();

const computedTray = computed(() => drawer.value.trays.find(t => t.name === props.tray));
// icon can be CreateNewFolder or PushPin depending on if it PINNED or ADDED TO PROJECT
// should start with Added to project, Added to tray, Added to Favorites
</script>
